import { environment } from '@environment/environment';
import * as moment from 'moment';

export class DateUtil {
    static changeDDMMtoMMDD(date: string) {
        const [day, month, year] = date?.split('/');
        const result = [month, day, year]?.join('/');
        return result;
    }

    static sumOneDayInDate(date: string) {
        return new Date(new Date(DateUtil.changeDDMMtoMMDD(date)).getFullYear(), new Date(DateUtil.changeDDMMtoMMDD(date)).getMonth(), new Date(DateUtil.changeDDMMtoMMDD(date)).getDate() + 1);
    }

    static changeDDMMYYtoYYMMDD(date: string) {
        const [day, month, year] = date?.split('/');
        const result = [year, month, day]?.join('/');
        return result;
    }

    static isDateValid(date: string) {
        if (environment.defaultLanguage === 'pt-BR') {
            return moment(date, environment.defaultDateInput, true).isValid();
        } else {
            return moment(date, 'MM/DD/YYYY', true).isValid();
        }
    }

    static isHourValid(hour: string) {
        if (environment.defaultLanguage === 'pt-BR') {
            return moment(hour, 'HH:mm', true).isValid();
        } else {
            return moment(hour, 'hh:mm A', true).isValid();
            }
    }

    static changeDDMMYYYYtoYYYYYMMDD(dateString: string): string {
        if (!dateString) return '';
        const [month, day, year] = dateString.split('/');
        return `${month}/${day}/${year}`; // Retorna no formato YYYY-MM-DD
    }

    static formatTo12Hour(hourString: string): string {
        if (!hourString || !hourString.includes(':')) {
            console.error(`Invalid hourString format: ${hourString}`);
            return '';
        }

        // Remover o sufixo AM/PM, se existir
        const cleanHourString = hourString.replace(/AM|PM/gi, '').trim();

        const [hourPart, minutePart] = cleanHourString.split(':').map(Number);

        if (isNaN(hourPart) || isNaN(minutePart)) {
            console.error(`Invalid hour or minute: hour=${hourPart}, minute=${minutePart}`);
            return '';
        }

        const period = hourPart >= 12 ? 'PM' : 'AM';
        const formattedHour = hourPart % 12 || 12; // Converte para formato 12 horas
        return `${formattedHour}:${minutePart.toString().padStart(2, '0')} ${period}`;
    }

    static formatTo24Hour(hourString: string): string {
        if (!hourString) return '';
        return hourString; // Mantém o formato original de 24 horas
    }
}
